import type { SidebarItem } from "@/components/app-sidebar";

/**
 * Sidebar items that are real routes, reachable directly from any page.
 * Used by both `home-client.tsx` (already on "/") and `SubPageLayout` (on
 * some other routed page) so a sidebar click never has to bounce through
 * "/" first via the `?nav=` deep link — that bounce is reserved for items
 * still backed by an in-app dialog/panel inside `home-client.tsx`.
 */
export const SIDEBAR_ROUTES: Partial<Record<SidebarItem, string>> = {
  search: "/chats",
  team: "/teams",
  agents: "/agents",
  automations: "/automations",
  code: "/code",
  prompts: "/prompts",
  meetings: "/meetings",
  widgets: "/widgets",
  projects: "/projects",
  "agent-requests": "/agents/requests",
  "widget-requests": "/widgets/requests",
  "file-requests": "/files/requests",
  journey: "/journey",
  roadmap: "/roadmap",
  "ai-models": "/models",
  notifications: "/notifications",
  announcements: "/announcements",
  "meeting-minutes-admin": "/meetings/admin",
  "external-apps": "/external-apps",
};
